import { render } from "./poll.answer.control.vue?vue&type=template&id=57826152"
import script from "./poll.answer.control.vue?vue&type=script&lang=js"
export * from "./poll.answer.control.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__